import { getAllHomeRequest } from "../repositories/home_repository";
export const HomeService = () => {
    const fetchAllHomeData = async (setHomeList, setSponsorData, setSponsorAds, setLeagueCommitteeMembers, setWinningTeams,
         setManOfTheMatchList, setUmpireDetails, setAboutLeagueDetails
    ) => {
        try {
            
            const response = await getAllHomeRequest();
            if (response?.success) {
                setHomeList(response.data.home);
                setSponsorData(response.data.sponsor);
                setSponsorAds(response.data.sponsor_ad);
                setLeagueCommitteeMembers(response.data.league_committee_member);
                setWinningTeams(response.data.winning_team);
                setManOfTheMatchList(response.data.man_of_the_match);
                setUmpireDetails(response.data.umpire);
                setAboutLeagueDetails(response.data.about_league);
            }
        } catch (error) {
            console.error("Failed to fetch home data.")
        }
    };
    return {
        fetchAllHomeData,
    };
};